module.exports = __webpack_public_path__ + "static/media/trending.2f79aaf9.svg";